import { useGetOgpImageQuery } from 'src/types/generated'

type Input = {
  fromUrl: string
  skip?: boolean
}

export const useGetOgpImage = ({ fromUrl, skip }: Input) => {
  const { loading, data, error, refetch } = useGetOgpImageQuery({
    variables: { url: fromUrl },
    // fromUrlが空の場合もskipする
    skip: skip || !fromUrl,
  })

  return {
    loading,
    url: data?.ogpImage?.url,
    error,
    refetch,
  }
}
